import axios from 'axios'

const issuance_request_download = {
  namespaced: true,

  state() {
    return {
      data: {
        id: null,
        status: null,
        issue_expire_date: null,
        issues: [],
        building: {
          management_company: {
            reissue_possible_type: null,
            use_receipt: false,
          },
        },
      },
      password: null,
      payment_method: null,
      receipt_issued_status: null,
      billing_price: null,
      errors: {},
    };
  },
  mutations: {
    setPassword(state, payload) {
      state.password = payload.value;
    },
    setData(state, data) {
      state.data.id = data.id;
      state.data.status = data.status;
      state.data.issue_expire_date = data.issue_expire_date;
      state.data.issues = data.issues;
      state.data.building.management_company.reissue_possible_type = data.building.management_company.reissue_possible_type;
      state.data.payment_method = data.payment_method;
      state.data.receipt_issued_status = data.receipt_issued_status;
      state.data.building.management_company.use_receipt = data.building.management_company.use_receipt;
      state.data.billing_price = data.billing_price;
    },
    resetData(state) {
      state.data.id = null;
      state.data.status = null;
      state.data.issue_expire_date = null;
      state.data.issues = [];
      state.data.building.management_company.reissue_possible_type = null;
      state.data.payment_method = null;
      state.data.receipt_issued_status = null;
      state.data.building.management_company.use_receipt = false;
      state.data.billing_price = null;
    },
    setErrors(state, errors) {
      state.errors = { ...errors };
    },
    setError(state, payload) {
      state.errors[payload.key] = payload.value;
    },
    resetErrors(state) {
      state.errors = {};
    },
  },
  actions: {
    load({ commit }, payload) {
      commit('resetData');
      return new Promise((resolve, reject) => {
        axios.get('/api/issuance_requests/' + payload.id).then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    },
    submit({ state, commit }, payload) {
      commit('resetErrors');
      return new Promise((resolve, reject) => {
        axios.post(`/api/issues/${payload.uuid}/download`, {
          password: state.password,
        }).then((response) => {
          let base64 = response.data.data.file;
          let bin = atob(base64.replace(/^.*,/, ''));
          let buffer = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
          }

          const blob = new Blob([buffer.buffer], { type: response.data.data.content_type });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = response.data.data.file_name;
          link.click();

          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 400) {
            commit('setError', { key: 'password', value: ['パスワードが正しくありません。'] });
            handled = true;
          } else if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        });
      });
    },
    updateReceiptStatus({ state, commit }, payload){
      return new Promise((resolve, reject) => {
        axios.put('/api/issuance_requests/receipt_status/' + state.data.id, payload).then(() => {
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        });
      });
    },
  }
};

export default issuance_request_download;
